import React from "react";


const NoProductImage = ({scale}: {scale?: number}) => {

  return (
    <svg transform={`scale(${scale||1})`} width="44" height="44" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <g>
      <path
        d="M21 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14Z"
        stroke="currentColor"
        strokeWidth="1.6"
        opacity="0.65"
      />
      <path
        d="M8.5 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        fill="currentColor"
        opacity="0.65"
      />
      <path
        d="M21 15l-4.2-4.2a1 1 0 0 0-1.4 0L9 17l-2.1-2.1a1 1 0 0 0-1.4 0L3 17"
        stroke="currentColor"
        strokeWidth="1.6"
        opacity="0.65"
      />
      </g>
    </svg>
  )
}

export default NoProductImage;